export default class ReturnVisitRecordDto {
/**
 *
 * @type {string}
 * @memberof ReturnVisitRecordDto
 */
id?: any
/**
 *
 * @type {string}
 * @memberof ReturnVisitRecordDto
 */
maintainRecordId?: any
/**
 *
 * @type {Date}
 * @memberof ReturnVisitRecordDto
 */
returnVisitTime?: any
/**
 *
 * @type {string}
 * @memberof ReturnVisitRecordDto
 */
returnVisitBy?: any | null
/**
 *
 * @type {string}
 * @memberof ReturnVisitRecordDto
 */
returnVisitContent?: any | null
/**
 *
 * @type {number}
 * @memberof ReturnVisitRecordDto
 */
satisfaction?: any
/**
 *
 * @type {string}
 * @memberof ReturnVisitRecordDto
 */
no?: any | null
/**
 *
 * @type {string}
 * @memberof ReturnVisitRecordDto
 */
schoolShortName?: any | null
/**
 *
 * @type {string}
 * @memberof ReturnVisitRecordDto
 */
vehicleNO?: any | null
/**
 *
 * @type {string}
 * @memberof ReturnVisitRecordDto
 */
contactPhone?: any | null
/**
 *
 * @type {string}
 * @memberof ReturnVisitRecordDto
 */
contactBy?: any | null
/**
 *
 * @type {string}
 * @memberof ReturnVisitRecordDto
 */
contactReason?: any | null
/**
 *
 * @type {string}
 * @memberof ReturnVisitRecordDto
 */
assignBy?: any | null
}
